<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { Button, Text, Toggle, Slider } from '@Shelly/shelly-design-system';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { real_id } from 'src/helpers/interface_helpers';
	import { gen2Request } from 'src/services/gen_2_http_reqs';
		import type { SettingRequest } from 'src/types/requests/settings/setting';
	import { format } from 'svelte-i18n';

	$: settingsStore = getDeviceSettings(device.id);
	export let device;

	const min = 1;
	const max = 100;

	let loading = false;

	let enabled =
		$settingsStore?.[`light:${device.channel}`]?.button_presets
			?.button_doublepush !== null;
	let cacheEnabled = enabled;
	let brightness = enabled
		? $settingsStore?.[`light:${device.channel}`]?.button_presets
				?.button_doublepush?.brightness
		: 100; //setting default brightness to 100% because this is correct value for web ui
	let cacheBrightness = brightness;
	const toggleValue = (e) => {
		enabled = e.target.checked;
	};

	const sendReq = async () => {
		if (cacheBrightness !== brightness || cacheEnabled !== enabled) {
			loading = true;
			const params = enabled
				? {
						id: device.channel,
						config: {
							button_presets: {
								button_doublepush: {
									key: 'button_doublepush',
									enabled: enabled,
									brightness: brightness,
								},
							},
						},
					}
				: {
						id: device.channel,
						config: {
							button_presets: {
								button_doublepush: null,
							},
						},
					};

			const res: SettingRequest = await gen2Request(device, 'Light.SetConfig', params);

			const response = await onSettingsResponse(res, device);
			if (response.isok) {
				cacheBrightness = brightness;
				cacheEnabled = enabled;
			} else {
				brightness = cacheBrightness;
				enabled = cacheEnabled;
			}
			loading = false;
		}
	};
	const a11yProps = {
		sliderValueText: $format('current_brightness_value', {
			values: { value: brightness },
			default: `Current brightness value is ${brightness} percent`,
		}),
		ariaLabel: $format('label_set_brightness', { default: 'Set Brightness' }),
		ariaLabelValue: $format('current_brightness_value', {
			values: { value: brightness },
			default: `Current brightness value is ${brightness} percent`,
		}),
	};
</script>

<Text styleType="body-small" class="mb-s"
	>{$format('description_change_brightness_level', {
		default: 'Change the brightness level on action',
	})}</Text
>

<Toggle checked={enabled} on:click={toggleValue} size="m" class="mb-s" id="toggle-ptlbumy"
	>{$format('action_on_btn_double_push', {
		default: 'On button double push',
	})}</Toggle
>

<Slider
	id="slider-t0l2xnp"
	{a11yProps}
	class="mb-s"
	value={brightness}
	on:value_change={(event) => {
		brightness = event.detail.value;
	}}
	title="Brightness"
	type="simple"
	{min}
	{max}
/>

<Button size="m" width="full" {loading} on:click={sendReq}>{$format('button_save')}</Button>
